import { useRef, useState } from "react";
import { ChecklistItems } from "@/bryntum-lib/models/ChecklistItems";
import { useSwivuChecklistItems, ALLOWED_IMAGE_TYPES } from "./useSwivuChecklistItems";

/**
 * Hook to manage image upload/removal for checklist items
 * Extracted from ChecklistItemRow for reusability
 */
export const useChecklistItemUpload = (item: ChecklistItems) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const { uploadChecklistItemImage, removeChecklistItemImage } = useSwivuChecklistItems();

  const handleFileUpload = async (file: File) => {
    if (!file) return;
    setIsUploadingImage(true);
    const success = await uploadChecklistItemImage(item, file);
    if (success && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setIsUploadingImage(false);
  };

  const handleRemoveImage = async () => {
    await removeChecklistItemImage(item);
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return {
    fileInputRef,
    isUploadingImage,
    handleFileUpload,
    handleRemoveImage,
    triggerFileInput,
    allowedImageTypes: ALLOWED_IMAGE_TYPES
  };
};
